import { Typography, useTheme, useMediaQuery } from '@mui/material';
import styled from 'styled-components';
import { containerPaddingPx } from './dialogStyledComponents';
import { Button, FlexContainer } from '@act/storybook';
import { ReactNode } from 'react';

export const DialogMainContent = styled.div`
  padding: 12px ${containerPaddingPx}px;
  overflow: auto;
  margin: 0 -${containerPaddingPx}px;
`;

export interface DialogFooterAction {
  text: string;
  type?: 'button' | 'submit';
  callback?: () => unknown;
  disabled?: boolean;
  isPrimary?: boolean;
  variant?: 'contained' | 'outlined';
  isLeft?: boolean;
  icon?: ReactNode;
  trackingProps?: Record<string, string>;
}

export const DialogFooter = (props: { actions?: DialogFooterAction[] }) => {
  const { actions } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const rightActions = actions.filter(a => !a.isLeft);
  const leftActions = actions.filter(a => !!a.isLeft);

  const getVariant = (action: DialogFooterAction) => {
    if (action?.isPrimary) {
      return 'contained';
    }
    if (action.variant) {
      return action.variant;
    }
    return null;
  };

  return (
    <FlexContainer
      direction={isMobile ? 'column' : 'row'}
      alignItems={isMobile ? 'stretch' : 'flex-start'}
      justifyContent={isMobile ? 'stretch' : 'flex-end'}
      padding={isMobile ? '16px 24px' : '8px 24px'}
      margin="0"
      gap={isMobile ? 1.5 : 1}
      overflow="visible"
      height="auto"
      width="100%"
      sx={{
        borderTop: 'solid 1px #dce4e8',
      }}
    >
      {leftActions.map((action, idx) => (
        <Button
          key={idx}
          sx={{
            width: isMobile ? '100%' : 'auto',
            marginRight: isMobile ? 0 : 'auto',
          }}
          onClick={action.callback ? action.callback : null}
          type={action.type || 'button'}
          disabled={action.disabled ?? false}
          variant={getVariant(action)}
          {...action.trackingProps}
        >
          {action.icon}
          <Typography variant="labelLarge">{action.text}</Typography>
        </Button>
      ))}
      {rightActions.map((action, idx) => (
        <Button
          key={idx}
          sx={{
            width: isMobile ? '100%' : 'auto',
          }}
          onClick={action.callback ? action.callback : null}
          type={action.type || 'button'}
          disabled={action.disabled ?? false}
          variant={getVariant(action)}
          {...action.trackingProps}
        >
          {action.icon}
          <Typography variant="labelLarge">{action.text}</Typography>
        </Button>
      ))}
    </FlexContainer>
  );
};
